
class IndexView {
    defaultOptions() {
        return {
            'selector': '.login-view',
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.onSubmit = this.onSubmit.bind(this);

        this.$container = $(this.settings.selector);
        if(this.$container.length <= 0){
            window.notify("Can't find container view with selector " + this.settings.selector,'danger');
        }

        this.$form = $('.login-form',this.$container);

        this.initialize();
    }

    initialize() {
        var self = this;

        let iframeUrl = window.App.get('oldAdminHomeUrl')+'/deconnect/?noRedirect=1';
        let $iframe = $('<iframe/>')
        .css('display','none')
        .attr('src',iframeUrl)
        .attr('height',100)
        .attr('width',100);

        this.$container.append($iframe);

        this.$form.one('submit',this.onSubmit);
    }

    onSubmit(event){
        var self = this;

        event.preventDefault();

        let oldAdminUrl = window.App.get('oldAdminBaseUrl')+'/auth.php';

        let login = $('input[name="login"]',this.$form).val();
        let password = $('input[name="password"]',this.$form).val();

        $.ajax({
            'url': oldAdminUrl,
            'method': 'POST',
            'data': {
                'admin_login': login,
                'admin_pwd': password
            },
            'beforeSend': function(xhr){
               xhr.withCredentials = true;
            }
        })
        .done(function(sessionId){
            let iframeUrl = oldAdminUrl+'?sessId='+sessionId;
            let $iframe = $('<iframe/>')
            .css('display','none')
            .attr('src',iframeUrl)
            .attr('height',100)
            .attr('width',100);

            self.$container.append($iframe);
            //call real submit when iframe is loaded
            $iframe.on('load',function(){
                self.$form.submit();    
            })
            
        })
        .fail(function(xhr){
            //call real submit
            self.$form.submit();
        })
        .always(function(){
            
        });

    }
}

module.exports = IndexView;

